import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../app.config";
var AutocompleteService = /** @class */ (function () {
    function AutocompleteService(http, config) {
        this.http = http;
        this.config = config;
    }
    AutocompleteService.prototype.getCustomers = function (term) {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/ac/customers/" + encodeURIComponent(term));
    };
    AutocompleteService.prototype.getLocations = function (type, term, sessionId) {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/ac/locations/" + encodeURIComponent(type) + "/" + encodeURIComponent(sessionId) + "/" + encodeURIComponent(term));
    };
    AutocompleteService.prototype.getVehicleModels = function (term) {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/ac/vehiclemodels/" + encodeURIComponent(term));
    };
    AutocompleteService.ngInjectableDef = i0.defineInjectable({ factory: function AutocompleteService_Factory() { return new AutocompleteService(i0.inject(i1.HttpClient), i0.inject(i2.AppConfig)); }, token: AutocompleteService, providedIn: "root" });
    return AutocompleteService;
}());
export { AutocompleteService };
